module.exports = __webpack_public_path__ + "img/gallery_active.1b9c56b8.svg";